enum RequisitionStatus {
	WAITING = 'WAITING', 
	CANCELLED = 'CANCELLED', 
	APPROVED = 'APPROVED', 
	REJECTED = 'REJECTED'
}

export default RequisitionStatus;